import { err, ok, Result, Unit } from "../result";
import { ProblemDetails } from "../models/Http";
import {
  AwaitingStocktakingCounts,
  CreateStocktaking,
  LockedItem,
  ProcessedItem,
  StoreStocktakingItem
} from "../models/Stocktaking";
import { del, get, post } from "./api";
import moment from "moment";

export const getAwaitingCounts = async (
  storeIds: string[] = []
): Promise<Result<ProblemDetails, AwaitingStocktakingCounts>> => {
  let additionalQuery = "";

  storeIds.forEach((val, index) => {
    additionalQuery =
      index === 0 ? `?storeIds=${val}` : `${additionalQuery}&storeIds=${val}`;
  });

  const response = await get(
    `/v1/stock-taking/awaiting-counts${additionalQuery}`
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as AwaitingStocktakingCounts);
  }

  return err(content as ProblemDetails);
};

export const create = async (
  model: CreateStocktaking
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post(`/v1/stock-taking`, model);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const stop = async (
  storeId: string
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await del(`/v1/stock-taking?storeId=${storeId}`);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const listAwaitingInStores = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>
> => {
  const response = await get(`/v1/stock-taking/stores/all/awaiting`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<StoreStocktakingItem>);
  }

  return err(content as ProblemDetails);
};

export const listAwaitingByStore = async (
  storeId: string
): Promise<Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>> => {
  const response = await get(`/v1/stock-taking/stores/${storeId}/awaiting`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<StoreStocktakingItem>);
  }

  return err(content as ProblemDetails);
};

export const reportByStore = async (
  storeId: string,
  items: ReadonlyArray<StoreStocktakingItem>
): Promise<Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>> => {
  const response = await post(`/v1/stock-taking/stores/${storeId}`, items);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<StoreStocktakingItem>);
  }

  return err(content as ProblemDetails);
};

export const updateReportedProductStocktaking = async (
  storeStocktakingId: string,
  onShelf: number
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post(
    `/v1/stock-taking/store-stocktaking/${storeStocktakingId}`,
    onShelf
  );

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const getLockedItems = async (
  storeId: string
): Promise<Result<ProblemDetails, ReadonlyArray<LockedItem>>> => {
  const response = await get(`/v1/stock-taking/stores/${storeId}/lock`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<LockedItem>);
  }

  return err(content as ProblemDetails);
};

export const lockItem = async (
  storeId: string,
  itemId: string,
  lock: boolean
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post(`/v1/stock-taking/stores/${storeId}/lock`, {
    itemId,
    lock
  });

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};

export const getProcessedItems = async (
  storeId: string,
  created: Date
): Promise<Result<ProblemDetails, ReadonlyArray<ProcessedItem>>> => {
  const response = await post(
    `/v1/stock-taking/stores/${storeId}/process/list`,
    { created: created }
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<ProcessedItem>);
  }

  return err(content as ProblemDetails);
};

export const processItem = async (
  storeId: string,
  item: StoreStocktakingItem
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post(
    `/v1/stock-taking/stores/${storeId}/process`,
    item
  );

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};
